import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { TableContext } from '../../../Table/TableContext';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';
import useResolveComplaintStepOne from '../../../../hooks/dashboard/BaDriverVerification/useResolveComplaintStepOne';
//
interface ComplaintViewProps {
  data: any;
}

const ComplaintView: React.FC<ComplaintViewProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);

  const { resetSliderIndex, setSliderIndexPos, sliderIndex } = useContext(
    TranslatingContainerContext,
  )!;

  const { resolveComplaint, loading } = useResolveComplaintStepOne();

  const onResolve = () => {
    resolveComplaint(data?.id ?? '', () => {
      modalContext?.setShowModal(false);
      tableContext?.setRefreshTable(!tableContext?.refreshTable);
      resetSliderIndex();
    });
  };

  return (
    <Container className={sliderIndex > 0 ? 'inactive' : ''}>
      <Item>
        <ItemLabel>Reason for Rejection</ItemLabel>
        <ItemValue>{data?.rejectionReason ?? 'N/A'}</ItemValue>
      </Item>

      <Item>
        <ItemLabel>Customer Complaint</ItemLabel>
        <ItemValue>{data?.complaint ?? 'N/A'}</ItemValue>
      </Item>

      <ButtonArea>
        <ResolveButton onClick={onResolve} disabled={loading}>
          Resolve
        </ResolveButton>
        <NextButton onClick={() => setSliderIndexPos(1)}>Next</NextButton>
      </ButtonArea>
    </Container>
  );
};

export default ComplaintView;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  padding: 16px;

  &.inactive > * {
    display: none;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ItemLabel = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #4b5563;
`;

const ItemValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background: #f5f5f5;
  border-radius: 4px;
  padding: 10px 16px;
`;

const ResolveButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  background: white;
  cursor: pointer;
`;

const NextButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  background: white;
  cursor: pointer;
  background: linear-gradient(
    262.94deg,
    #436db8 9.61%,
    #5b91f5 49.28%,
    #3c80ff 85.91%
  );
  color: white;
`;

const ButtonArea = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
